module.exports = __webpack_public_path__ + "static/media/Google.7d9d2ccb.svg";